export default {"src":"/_next/static/media/tilapia.d58c73c5.svg","height":512,"width":512,"blurWidth":0,"blurHeight":0};